const LABELS = {
  // Header Contact Info
  SUPPORT_PHONE: "+91 6381067878",
  SUPPORT_EMAIL: "orders@dailyneeds.com",
  TOPBAR_MSG: "🎉 Save 5% on orders over $10 • Save 10% on orders over $85",
  PROMOTIONAL_HEADER_MSG: "Get 10% off on your first order! Use code: DAILY10 at checkout.",
  //LOGO
  LOGO: {
    webImageUrl: "/assets/site/images/logo.png",
    mobileImageUrl: "/assets/site/images/logo.png",
  },
  // Site Info
  SITE_NAME: "DAILY NEEDS WORLD",
  DEFAULT_COUNTRY: "United States",
  DEFAULT_CURRENCY: "USD",
  SEARCH_PLACEHOLDER: "Search",
  FACEBOOK_LINK: "https://facebook.com/dailyneedsworld",
  INSTAGRAM_LINK: "https://instagram.com/dailyneedsworld",
  PINTEREST_LINK: "https://pinterest.com/dailyneedsworld",
  TWITTER_LINK: "https://twitter.com/dailyneedsworld",
  YOUTUBE_LINK: "https://youtube.com/@dailyneedsworld",
  LINKEDIN_LINK: "https://linkedin.com/company/dailyneedsworld",

  //SOCIAL ICONS
  SOCIAL_ICONS: [
    {
      label: "Facebook",
      key: "FACEBOOK",
      url: "https://facebook.com/dailyneedsworld",
      icon: "Facebook",
    },
    {
      label: "Instagram",
      key: "INSTAGRAM",
      url: "https://instagram.com/dailyneedsworld",
      icon: "Instagram",
    },
    {
      label: "YouTube",
      key: "YOUTUBE",
      url: "https://youtube.com/@dailyneedsworld",
      icon: "Youtube",
    },
    {
      label: "Twitter",
      key: "TWITTER",
      url: "https://twitter.com/dailyneedsworld",
      icon: "Twitter",
    },
  ],

  // Navigation Menu
  NAVIGATION: [
    { label: "Home", href: "/", status: true },
    { label: "Shop", href: "/shop", status: true },
    {
      label: "Crazy Discount Deals",
      href: "/crazy-deals",
      status: true,
    },
    { label: "Contact", href: "/contact", status: true },
  ],

  // Menu Categories (with icons)
  MENU_CATEGORIES: [
    {
      label: "Montessori Toys",
      icon: "FiGrid",
      href: "/montessori",
      status: 1,
    },
    { label: "Movable Vehicles", icon: "LuCar", href: "/vehicles", status: 1 },
    {
      label: "Art & Stationary",
      icon: "LuPaintbrush",
      href: "/art",
      status: 1,
    },
    { label: "Books", icon: "LuBookOpen", href: "/books", status: 1 },
    {
      label: "Creative Toys",
      icon: "LuPuzzle",
      href: "/creative",
      status: 1,
    },
    {
      label: "Pretend Toys",
      icon: "PiChalkboardTeacherLight",
      href: "/pretend",
      status: 1,
    },
  ],

  // Banner Section
  BANNER: [
    {
      key: "BANNER_1",
      headingLine1: "TOYS KIDS",
      headingLine2: "BAZAAR AND FESTIVAL",
      subtext: "COME EXPLORE THE MAGIC OF CHILDHOOD AT OUR KIDS TOY BAZAAR!",
      webImageUrl: "/assets/site/images/banner.png",
      mobileImageUrl: "/assets/site/images/banner.png",
    },
    {
      key: "BANNER_2",
      headingLine1: "FUN & LEARN",
      headingLine2: "WOODEN TOY COLLECTION",
      subtext: "SAFE, SUSTAINABLE & SKILL-BUILDING TOYS FOR YOUR LITTLE ONES",
      webImageUrl: "/assets/site/images/banner1.png",
      mobileImageUrl: "/assets/site/images/banner4.png",
    },
  ],

  // shop by category

  SHOPBYCATEGORIES: [
    {
      id: 2,
      label: "Montessori Toys",
      image: "/assets/site/images/age_1.png",
    },
    {
      id: 3,
      label: "Open Ended Toys",
      image: "/assets/site/images/age_2.png",
    },
    {
      id: 4,
      label: "Movable Vehicles",
      image: "/assets/site/images/age_3.png",
    },
    {
      id: 5,
      label: "Creative Toys",
      image: "/assets/site/images/age_4.png",
    },
    {
      id: 6,
      label: "Pretend Play Toys",
      image: "/assets/site/images/age_5.png",
    },
    {
      id: 7,
      label: "Logical Toys",
      image: "/assets/site/images/age_6.png",
    },
    {
      id: 8,
      label: "Non Wooden Toys",
      image: "/assets/site/images/age_7.png",
    },
    {
      id: 9,
      label: "Books",
      image: "/assets/site/images/age_8.png",
    },
    {
      id: 10,
      label: "Art And Stationary",
      image: "/assets/site/images/stationary_toys.png",
    },
  ],
  //Promotional banner
  PROMOTIONBANNER: {
    image: "/assets/site/images/logical_toys.png",
    TEXT: "🎁 Get 20% off on Educational Toys!",
    POSITION: "right",
  },

  //company overview

  COMPANY_OVERVIEW_HEADING: "Company Overview",
  // COMPANY_OVERVIEW:
  //   "Hi5 Toys is an Indian brand dedicated to creating eco-friendly, handcrafted wooden toys that spark imagination and foster learning in children Hi5 Toys offers a wide range of products, including Montessori toys, open-ended play items, creative kits, and educational games, all designed to support children's developmental growth. The brand emphasizes heirloom-quality craftsmanship, ensuring that each toy is not only safe and durable but also inspires creativity and learning.",

  //footer section
  FOOTER_CONTENT: {
    tagline: "LATEST SHOWS",
    description: "We sell best quality appliances | CookTop...",
    social: [
      { icon: "linkedin", url: "https://linkedin.com", status: "true" },
      { icon: "facebook", url: "https://facebook.com" },
      { icon: "instagram", url: "https://instagram.com" },
    ],
  },
  FOOTER_QUICKLINKS: [
    { label: "Home", href: "/" },
    { label: "About Us", href: "/about" },
    { label: "On The News", href: "/news" },
    { label: "Contact Us", href: "/contact" },
    { label: "FAQ", href: "/faq" },
    { label: "My Account", href: "/account" },
  ],

  FOOTER_POLICIES: [
    { label: "Terms and Conditions", href: "/terms" },
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Shipping Policy", href: "/shipping" },
    { label: "Returns and Refund Policy", href: "/returns" },
  ],
  DOWNLOAD: {
    playStoreUrl: "https://play.google.com/store",
    whatsappUrl: "https://wa.me/919876543210",
  },
  CART: {
    TITLE: "Shopping Cart",
    FREE_SHIPPING_PREFIX: "Free shipping on orders over ",
    EMPTY_TITLE: "Your Cart is Empty",
    EMPTY_MESSAGE: "Looks like you haven't added any items to your cart yet.",
    CONTINUE_SHOPPING: "Continue Shopping",

    NO_STOCK: "No Stock",
    OUT_OF_STOCK: "Out of stock",
    FREE_PRODUCT: "Free Product",
    CONFIRM_DELETE_TITLE: "Remove Item",
    CONFIRM_DELETE_MSG: "Are you sure you want to remove this item from your cart?",
    CONFIRM_LABEL: "Yes, remove",
    CANCEL_LABEL: "Cancel",
  },
  CART_SUMMARY: {
    TITLE: "Cart Summary",
    COUPON_LABEL: "Coupon code:",
    COUPON_PLACEHOLDER: "Coupon code",
    COUPON_APPLY: "Apply",
    COUPON_APPLYING: "Applying...",
    COUPON_SUCCESS: "Coupon applied successfully",
    COUPON_ENTER_ERROR: "Please enter a coupon code.",
    SUBTOTAL: "Subtotal",
    TAX: "Tax",
    SHIPPING: "Shipping Charge",
    DISCOUNT: "Discount",
    TOTAL: "Total",
    CHECKOUT_BUTTON: "Proceed to Checkout",
  },
  PAYMENT_METHODS: {
    TITLE: "Payment Method",
    SECURITY_MESSAGE: "All transactions are secure and encrypted.",
  },
  SIGN_IN: {
    TITLE: "Sign In",
    SUBTITLE: "Access your account and track your orders.",
    EMAIL_LABEL: "Email",
    EMAIL_PLACEHOLDER: "Enter your email ",
    PASSWORD_LABEL: "Password",
    PASSWORD_PLACEHOLDER: "Enter your password",
    FORGOT_PASSWORD: "Forgot Password?",
    SUBMIT_BUTTON: "Sign In",
    SUBMIT_LOADING: "Signing in...",
    NEW_HERE: "New here?",
    CREATE_ACCOUNT: "Create an account",
    SECURITY_MESSAGE: "Your information is safe with us",
  },
  METADATA: {
    TITLE: "Daily Needs World",
    DESCRIPTION: "Ecommerce app",
  },
  ORGANIZATION: {
    NAME: "Daily Needs World",
    LOGO: "https://www.dailyneedsworld.com/assets/images/logo-color.png",
    URL: "https://www.dailyneedsworld.com",
  },
  BRAND: {
    NAME: "Daily Needs Products",
    FULL_NAME: "Daily Needs Products",
    PRODUCT_OF: "Daily Needs Products",
    ABOUT_FALLBACK: "Indian items for your daily needs",
    DEFAULT_ADDRESS: "883 N Shoreline Blvd, Suite B220",
    DEFAULT_CITY: "Mountain View",
    DEFAULT_STATE: "CA",
    DEFAULT_ZIP: "94043",
    DEFAULT_COUNTRY: "United States",
    DEFAULT_PHONE: "+1-855-253-4782",
    DEFAULT_EMAIL: "happy@dailyneedsworld.com",
  },
  HEADER: {
    MENU_TITLE: "Menu",
    LOGIN_REGISTER: "Login / Register",
    MY_PROFILE: "My Profile",
    VIEW_CART: "View Cart",
    CART_TOOLTIP: "Shopping cart",
    STORE_DETAILS_TOOLTIP: "Store details",
    PROFILE_TOOLTIP: "Profile",
    SIGN_IN_TOOLTIP: "Sign in",
  },
  FOOTER: {
    QUICK_LINKS_TITLE: "Quick Links",
    CONTACT_TITLE: "Contact",
    POLICIES_TITLE: "Policies",
    COPYRIGHT_PREFIX: "All rights reserved.",
    DOMAIN: "dailyneedsworld.com",
    ABOUT_TITLE: "About Us",
    CATEGORIES_TITLE: "Categories",
    ACCOUNT_TITLE: "Account",
    SERVING_LOCATIONS_TITLE: "Serving Locations",
    CONTACT_US_TITLE: "Contact Us",
    CONNECT_WITH_US_TITLE: "Connect With Us",
  },
  ANALYTICS: {
    DEFAULT_EXTERNAL_SOURCE_DESC: "User came from an external site",
  },
};


export default LABELS;
